<template>
  <span class="badge">{{ value }}</span>
</template>
<script>
export default {
  props: ['value']
}
</script>
